import React, {Component} from "react";
import {connect} from 'react-redux'
import FJPanelAnimation from "../../../common/component/FJPanelAnimation/FJPanelAnimation";
import FJFilterView from "../view/FJFilterView";
import {FJGLFilterStore} from "fj-graph";
import {FJFilterAction} from "../../../redux/action/FJRoot.action";

class FJFilterContainer extends Component {

  constructor(props) {
    super(props);
    this.filter = [{type: 'none', name: 'none'}, ...FJGLFilterStore.allFilters()]
  }

  renderFilterToUrl = (type, image) => {
    let canvas = FJGLFilterStore.applyFilter({filter: {
        active: true,
        type,
        intensity: 1,
      }}, image);

    return canvas ? canvas.toDataURL() : image.src;
  };

  onFilterActiveChange = (active) => {
    this.props.onFilterActiveChange(active);
  };

  _render = () => {
    const {selectedType, intensity, filterActive} = this.props;
    const {onFilterChange, onIntensityChange, applyToAll} = this.props;
    return (
      <FJFilterView intensity={intensity}
                    applyToAll={applyToAll}
                    renderFilterToUrl={this.renderFilterToUrl}
                    onFilterActiveChange={this.onFilterActiveChange}
                    selectedType={selectedType}
                    filterActive={filterActive}
                    onFilterChange={onFilterChange}
                    onIntensityChange={onIntensityChange}
                    filters={this.filter}/>
    );
  };

  render() {
    const {isShow} = this.props;
    return (
      <FJPanelAnimation active={isShow} render={this._render} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedType: state.filter.filterType,
    intensity: state.filter.intensity,
    filterActive: state.filter.filterActive,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFilterChange: function (type) {
      dispatch(FJFilterAction.filterChangeAction(type));
    },
    onIntensityChange: function (data) {
      dispatch(FJFilterAction.intensityChangeAction(data));
    },
    onFilterActiveChange: function (active) {
      dispatch(FJFilterAction.filterActiveChangeAction(active));
    },
    applyToAll: function () {
      dispatch(FJFilterAction.applyToAllForFilterAction());
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJFilterContainer);

